"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.customer_allowed_properties_material_type = exports.customer_allowed_properties_material_tube = exports.customer_allowed_properties_material_sheet = void 0;
exports.fromTupleMaterials = fromTupleMaterials;
exports.removeHiddenPropertiesFromMaterialSheet = removeHiddenPropertiesFromMaterialSheet;
exports.removeHiddenPropertiesFromMaterialTube = removeHiddenPropertiesFromMaterialTube;
exports.removeHiddenPropertiesFromMaterialType = removeHiddenPropertiesFromMaterialType;
exports.toTupleMaterials = toTupleMaterials;
/** Map of material_sheet properties which customers are allowed to see */
const customer_allowed_properties_material_sheet = exports.customer_allowed_properties_material_sheet = {
  'availability_date': true,
  'bead_blasting_allowed': true,
  'bead_blasting_requires_finishing': true,
  'bend_min_flange_gt90': true,
  'bend_min_flange_lte90': true,
  'bend_radius_in': true,
  'bend_v_gap': true,
  'bending_allowed': true,
  'brushed_finishing_allowed': true,
  'enabled': true,
  'engrave_allowed': true,
  'flat_finishing_allowed': true,
  'fragile_feature_aspect_ratio': true,
  'fragile_feature_threshold': true,
  'id': true,
  'image': true,
  'k_factor': true,
  'kerf_width': true,
  'material_id': true,
  'max_aspect_ratio': true,
  'max_bend': true,
  'max_size_x': true,
  'max_size_y': true,
  'min_finish_area': true,
  'min_finish_feed_length': true,
  'min_finish_single_dimension': true,
  'min_hole_size': true,
  'min_part_single_dimension': true,
  'min_rec_channel_gap': true,
  'min_rec_hole_size': true,
  'min_rec_wall_thickness': true,
  'minus_tolerance': true,
  'plus_tolerance': true,
  'powder_coating_allowed': true,
  'powder_requires_finishing': true,
  'punch_radius': true,
  'sheet_name': true,
  'stocked': true,
  'tapping_allowed': true,
  'tapping_thread_depth': true,
  'thickness_tolerance': true,
  'thickness': true,
  'tumbling_allowed': true
};

/** Map of material_type properties which customers are allowed to see */
const customer_allowed_properties_material_type = exports.customer_allowed_properties_material_type = {
  'alloy': true,
  'brinell_hardness': true,
  'density_in3': true,
  'description': true,
  'details': true,
  'display_order': true,
  'elastic_modulus': true,
  'elongation_at_break': true,
  'fatigue_strength': true,
  'finish': true,
  'has_grain': true,
  'heat_capacity': true,
  'material_id': true,
  'name': true,
  'poissons_ratio': true,
  'shear_modulus': true,
  'shear_strength': true,
  'short_code': true,
  'supertype': true,
  'thermal_conductivity': true,
  'type_image': true,
  'type': true,
  'ultimate_tensile': true,
  'yield_tensile': true
};

/** Map of material_tube properties which customers are allowed to see */
const customer_allowed_properties_material_tube = exports.customer_allowed_properties_material_tube = {
  'availability_date': true,
  'bead_blasting_allowed': true,
  'corner_radius': true,
  'enabled': true,
  'has_weld_seam': true,
  'id': true,
  'material_id': true,
  'max_corner_radius': true,
  'max_length_in': true,
  'min_corner_radius': true,
  'nominal_pipe_size': true,
  'pipe_schedule': true,
  'powder_coating_allowed': true,
  'profile_part_id': true,
  'profile_size_x': true,
  'profile_size_y': true,
  'shape': true,
  'tumbling_allowed': true,
  'wall_thickness': true
};
/**
 * Returns a new object with only the properties in MaterialSheet that customers are allowed to see.
 */
function removeHiddenPropertiesFromMaterialSheet(materialSheet) {
  let customerMaterialSheet = {};
  for (let key in customer_allowed_properties_material_sheet) {
    // @ts-ignore - I know this is correct
    customerMaterialSheet[key] = materialSheet[key];
  }
  return customerMaterialSheet;
}

/**
 * Returns a new object with only the properties in MaterialType that customers are allowed to see.
 */
function removeHiddenPropertiesFromMaterialType(materialType) {
  let customerMaterialType = {};
  for (let key in customer_allowed_properties_material_type) {
    // @ts-ignore - I know this is correct
    customerMaterialType[key] = materialType[key];
  }
  return customerMaterialType;
}

/**
 * Returns a new object with only the properties in MaterialTube that customers are allowed to see.
 */
function removeHiddenPropertiesFromMaterialTube(materialTube) {
  let customerMaterialTube = {};
  for (let key in customer_allowed_properties_material_tube) {
    // @ts-ignore - I know this is correct
    customerMaterialTube[key] = materialTube[key];
  }
  return customerMaterialTube;
}
function toTuple(obj) {
  let keys = Object.keys(obj[0]);
  let values = obj.map(sheet => Object.values(sheet));
  return {
    keys,
    values
  };
}
function fromTuple(bundledObject) {
  let entries = bundledObject.values.map(entry => {
    return Object.fromEntries(entry.map((value, index) => [bundledObject.keys[index], value]));
  });
  return entries;
}
function toTupleMaterials({
  materialSheets,
  materialTypes,
  materialTubes
}) {
  return {
    bundledMaterialSheets: toTuple(materialSheets),
    bundledMaterialTypes: toTuple(materialTypes),
    bundledMaterialTubes: toTuple(materialTubes)
  };
}
function fromTupleMaterials({
  bundledMaterialSheets,
  bundledMaterialTypes,
  bundledMaterialTubes
}) {
  return {
    materialSheets: fromTuple(bundledMaterialSheets),
    materialTypes: fromTuple(bundledMaterialTypes),
    materialTubes: fromTuple(bundledMaterialTubes)
  };
}